import { useMediaQuery } from '@mui/material';
import { ImageCdn } from '@openclassrooms/images-cdn';

import { useTheme } from '@classify/react-core-components/styles';

import useBlueshiftLiveContent from '../../hooks/useBlueshiftLiveContent';
import { SlotNames } from '../../constants/blueshift';
import BlueShiftPopUp from './BlueShiftPopUp';

const PredictiveCRMPopUp = () => {
  const { liveContent } = useBlueshiftLiveContent(SlotNames.PopUp);
  const { breakpoints } = useTheme();
  const shouldSeeBanner = useMediaQuery(breakpoints.up('md'));

  if (!liveContent) {
    return null;
  }

  const { content, tracking } = liveContent;
  const bullets = ['bullet_1', 'bullet_2', 'bullet_3']
    .map((bulletPropertyName) => content[bulletPropertyName])
    .filter(Boolean) as string[];

  const firstButtonEvent = content?.firstButton?.dataEvent ?? {};
  const firstButtonDataEvent = firstButtonEvent
    ? `${firstButtonEvent?.type}::${firstButtonEvent?.category}::${firstButtonEvent?.action}::${firstButtonEvent?.label}`
    : '';

  const firstButtonProps = content?.firstButton && {
    children: content.firstButton.label,
    href: content.firstButton.url,
    'data-event': firstButtonDataEvent,
    target: content.firstButton.isTargetBlank ? '_blank' : undefined,
    ...(content.firstButton.variant && { variant: content.firstButton.variant }),
  };

  const secondButtonEvent = content?.secondButton?.dataEvent ?? {};
  const secondButtonDataEvent =
    secondButtonEvent &&
    `${secondButtonEvent?.type}::${secondButtonEvent?.category}::${secondButtonEvent?.action}::${secondButtonEvent?.label}`;

  const secondButtonProps = content?.secondButton && {
    children: content.secondButton.label,
    href: content.secondButton.url,
    'data-event': secondButtonDataEvent,
    target: content.secondButton.isTargetBlank ? '_blank' : undefined,
    ...(content?.secondButton.variant && { variant: content?.secondButton?.variant }),
  };

  return (
    <BlueShiftPopUp
      shouldSeeComponent={shouldSeeBanner}
      removeCloseButton={content.removeCloseButton}
      userId={content.userId ?? 'anonymous'}
      media={content.mediaUrl && <ImageCdn src={content.mediaUrl ?? null} alt="" />}
      storageKey={content.storageKey}
      title={content.title}
      description={content.subheading}
      bullets={bullets}
      firstButtonProps={firstButtonProps}
      secondButtonProps={secondButtonProps}
      trackingImpressionUrl={tracking?.impression_url}
      trackingClickUrl={tracking?.click_url}
    />
  );
};

export default PredictiveCRMPopUp;
